import { useMemo } from "react";

import { Tag, useGetAllTagsQuery } from "../../../redux/slices";
import { TMultiSelectItem, useMultiSelect } from "../../multi-select";
import { UseSelect } from "../types";
import { Playbook } from "../../../types/playbook/playbook";

export type SelectTagItem = TMultiSelectItem<Tag>;

export const useSelectTagsPlaybook = ({ editingPlaybook, updatePlaybookTags }: any) => {
  let { data: tags } = useGetAllTagsQuery();
  tags = tags || [];

  const tagItems: SelectTagItem[] = useMemo(
    (): SelectTagItem[] => tags?.map((tag) => ({ ...tag, id: tag.tag_id, label: tag.name })) || [],
    [tags]
  );

  const selectedTags = useMemo(
    (): SelectTagItem[] =>
      editingPlaybook.tags ? editingPlaybook.tags.map((t:any) => ({ ...t, id: t.tag_id, label: t.name })) : [],
    [editingPlaybook]
  );

  const handleChangeTags = (items: SelectTagItem[]) => {
    updatePlaybookTags((prevValue:any) => ({ ...prevValue, tags: items }));
  };

  const tagSelect = useMultiSelect({ items: tagItems, initialSelectedItems: selectedTags, onChange: handleChangeTags });

  return { tagSelect };
};
